import {AttributeLink} from '@acng/frontend-stargazer';

import {getLocalOverlay} from '../service/overlay';
import {Matcher} from '@acng/frontend-bounty/dom/element.js';
import {get} from '@acng/frontend-bounty/dom/attribute.js';
import {ONCLICK_TARGET} from 'acng/layout/attribute/onclick-target.js';
import {CLICK, on} from '@acng/frontend-bounty/dom/event.js';
import {guard, IS_ELEMENT} from '@acng/frontend-rubicon';
import {goBack} from '../service/location.js';

/**
 * @group DOM Attribute
 */
const name = 'onclick-close-overlay';

AttributeLink(name, (element) => {
  on(element, CLICK, ({target}) => {
    ASSERT: guard(target, IS_ELEMENT);

    if (Matcher(get(element, ONCLICK_TARGET))(target)) {
      const overlay = getLocalOverlay(element);

      if (overlay) {
        overlay.close();
      } else {
        goBack();
      }
    }
  });
});

export {};
